import React from 'react';
import '../App.css';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* Column 1: Logo & About */}
        <div className="footer-col">
          <div className="footer-logo">
            <h2><span>MR</span> WHITE</h2>
          </div>
          <p>Premium laundry, dry cleaning, and ironing services in the UAE. Quality care for your garments, delivered to your doorstep.</p>
          <div className="footer-social">
            <i className="fab fa-facebook-f"></i>
            <i className="fab fa-instagram"></i>
            <i className="fab fa-whatsapp"></i>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li>Home</li>
            <li>About Us</li>
            <li>Our Services</li>
            <li>How It Works</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* Column 3: Contact Info */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <div className="contact-item">
            <i className="fas fa-map-marker-alt"></i>
            <p>Business Bay, Dubai, UAE</p>
          </div>
          <div className="contact-item">
            <i className="fas fa-phone-alt"></i>
            <p>+971 50 123 4567</p>
          </div>
          <div className="contact-item">
            <i className="fas fa-envelope"></i>
            <p>hello@mrwhiteuae.com</p>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <p>&copy; 2026 MR WHITE LAUNDRY. All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;